import {getStoredAuthState} from '@utils/auth';
import {redirect} from 'react-router';

export const decodeJwtPayload = (
    token: string
): Record<string, unknown> | null => {
    const parts = token.split('.');
    if (parts.length !== 3) return null;
    try {
        const payload = parts[1]
            .replace(/-/g, '+')
            .replace(/_/g, '/')
            .padEnd(Math.ceil(parts[1].length / 4) * 4, '=');
        const json = atob(payload);
        return JSON.parse(json) as Record<string, unknown>;
    } catch {
        return null;
    }
};

export const redirectIfUser = async () => {
    if (getStoredAuthState() !== null) {
        return redirect('/');
    }

    return null;
};

export const requireAuth = async () => {
    if (getStoredAuthState() === null) {
        return redirect('/auth/login');
    }
    return null;
};
